import { OperationVariables, ApolloQueryResult } from '@apollo/client'
import { Fade, IconButton, TableSortLabel } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'
import React from 'react'

import { getTranslate } from '../../localization'
import { SortBy } from '../../types/walletEnums'
import {
  TransactionResponse,
  WalletTransaction
} from '../../types/walletTransaction'
import { WalletTransactionListTableRowDesktop } from './WalletTransactionListTableRowDesktop'
import { WalletTransactionListRowDesktopSkeleton } from './WalletTransactionListTableRowDesktop.Skeleton'
import useStyles from './styles/WalletListTableDesktop.styles'

interface WalletTransactionListTableProps {
  data: WalletTransaction[]
  loadingForTransactions?: boolean
  supportAvailable?: boolean
  setSort: React.Dispatch<React.SetStateAction<SortBy>>
  sort: SortBy
  setpage: React.Dispatch<React.SetStateAction<number>>
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      transactions: TransactionResponse
    }>
  >
}
export const WalletTransactionListTableDesktop: React.FC<
  WalletTransactionListTableProps
> = ({
  data,
  setSort,
  sort,
  refetch,
  setpage,
  loadingForTransactions,
  supportAvailable = false
}) => {
  const classes = useStyles()
  interface HeadCell {
    label: string
    id: string
  }
  const headCells: HeadCell[] = [
    { id: 'time', label: 'Time' },
    ...(data[0]?.creditorID ? [{ id: '2', label: 'Creditor' }] : []),
    { id: '3', label: 'Type' },
    { id: 'amount', label: 'Amount' },
    { id: '5', label: 'Effected Balance' },
    { id: '6', label: 'Penalty/Bounce' },
    { id: '7', label: 'Description' },
    { id: '8', label: 'Payment Status' },
    { id: '9', label: 'Status' }
  ]
  return (
    <div>
      <div
        className={
          data[0]?.creditorID
            ? classes.tableHead
            : classes.tableHeadWithoutCreditor
        }>
        {headCells.map((item) => (
          <div key={item.id}>
            <TableSortLabel
              className={classes.tableSortLabel}
              active={item.id === 'time' || item.id === 'amount' ? true : false}
              onClick={() => {
                setSort(
                  item.id === 'time' || item.id === 'amount'
                    ? item.id
                    : 'dectime'
                )

                if (sort === item.id) {
                  setSort(('dec' + item.id) as SortBy)
                }
              }}
              hideSortIcon
              direction={item.id === sort ? 'desc' : 'asc'}>
              {getTranslate(item.label)}
            </TableSortLabel>
          </div>
        ))}

        <div className={classes.refreshButtonContainer}>
          <IconButton
            onClick={() => {
              setpage(1)
              refetch()
            }}>
            <RefreshIcon fontSize="small" />
          </IconButton>
        </div>
      </div>
      {loadingForTransactions
        ? Array(5)
            .fill('')
            .map((item, index) => (
              <WalletTransactionListRowDesktopSkeleton
                key={`accommodation-skeleton${item}${index.toString()}`}
              />
            ))
        : data.map((singleTransaction: WalletTransaction) => (
            <Fade in timeout={600} key={singleTransaction.transactionID}>
              <WalletTransactionListTableRowDesktop
                data={singleTransaction}
                supportAvailable={supportAvailable}
              />
            </Fade>
          ))}
    </div>
  )
}
